/**
 * Pitch Deck
 * One edition behind its password gate, then the fullscreen viewer
 */

import React, { useState, useEffect } from 'react';
import type { DeckEdition } from '@components/press/pitch-deck/pitch-deck.types';
import { PasswordGate } from '@components/press/pitch-deck/password-gate';
import { SlideViewer } from '@components/press/pitch-deck/slide-viewer';

export const PitchDeck: React.FC<{ edition: DeckEdition }> = ({ edition }) => {
  const [watermark, setWatermark] = useState<string | null>(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (watermark === null) {
    return (
      <PasswordGate
        meta={edition.meta}
        passwords={edition.passwords}
        onSuccess={(wm) => setWatermark(wm)}
      />
    );
  }

  return <SlideViewer edition={edition} watermark={watermark} />;
};
